<script>
	import { Router } from 'svelte-router-spa'
	import { routes } from './routes.js';
	import Alerts from '/core/components/alerts/Alerts.svelte';    	
    import LoaderDots from '/core/components/layout/LoaderDots.svelte';   

</script>

<main>
    <div class='page-bkg-wrapper'>
        <LoaderDots/>

        <div class="container-fluid page-content-wrapper">

            <Alerts/>            

            <div class='page-router-wrapper'>

                <Router {routes} />

            </div>            

        </div>

    </div>

</main>

<style>
    .page-content-wrapper {
        margin: 0;
        padding: 0;
    }
    .page-router-wrapper {
        padding: 0em 0em;
    }       

</style>